export const noteMapping = {
  1: {
    emoji: '🤬',
    stars: '⭐',
    text: 'very_unsatisfactory',
    bgColor: 'var(--danger-100)',
    borderColor: 'var(--danger-300)',
    textColor: 'var(--danger-600)',
  },
  2: {
    emoji: '😞',
    stars: '⭐⭐',
    text: 'unsatisfactory',
    bgColor: 'var(--danger-100)',
    borderColor: 'var(--danger-300)',
    textColor: 'var(--danger-600)',
  },
  3: {
    emoji: '😐',
    stars: '⭐⭐⭐',
    text: 'regular',
    bgColor: 'var(--warning-100)',
    borderColor: 'var(--warning-300)',
    textColor: 'var(--warning-600)',
  },
  4: {
    emoji: '😊',
    stars: '⭐⭐⭐⭐',
    text: 'satisfactory',
    bgColor: 'var(--warning-100)',
    borderColor: 'var(--warning-300)',
    textColor: 'var(--warning-600)',
  },
  5: {
    emoji: '🤩',
    stars: '⭐⭐⭐⭐⭐',
    text: 'excellent',
    bgColor: 'var(--success-100)',
    borderColor: 'var(--success-300)',
    textColor: 'var(--success-700)',
  },
} as const

export const getNoteDisplay = (note: number) => {
  const noteData =
    noteMapping[note as keyof typeof noteMapping] || noteMapping[3]
  return noteData
}

export type ScoreVisualizationEnum = 'emoji' | 'progress' | 'stars'
